/** @format */

import React, { useEffect, useState } from "react";
import { ReactComponent as BoxArrowUpRight } from "bootstrap-icons/icons/box-arrow-up-right.svg";
import { ResourceLink } from "../../../types";
import { fileIcon } from "../resourcePage/ResourcePageUI";
import { getUniqueCategories } from "../../../utils/functions";
import { DEFAULT_CATEGORY_NAME } from "../resourceLinks/ResourceLinksReducer";

type Props = {
  links: ResourceLink[];
};

const ResourceFiles: React.FC<Props> = ({ links }) => {
  const [categories, setCategories] = useState<string[]>();

  useEffect(() => {
    setCategories(getUniqueCategories(links));
  }, [links]);

  return (
    <>
      {categories && (
        <>
          {categories.map((cat, index) => {
            return (
              <div key={index}>
                {cat !== DEFAULT_CATEGORY_NAME && <h4 data-testid="catTitle">{cat}</h4>}
                <ul className="list-unstyled">
                  {links
                    .filter((link) => link.category === cat)
                    .map((link) => (
                      <li key={link.src + "-" + link.label}>
                        <a
                          title={link.label}
                          className="text-start btn btn-light btn-md py-0"
                          href={link.src}
                          rel="noreferrer"
                          target="_blank"
                          download
                          data-testid="file"
                        >
                          {fileIcon(link.mimeType)} {link.label}{" "}
                          <small className="fs-6 text-muted">
                            <BoxArrowUpRight />
                          </small>
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

export default ResourceFiles;
